import React from 'react';
import { useSite } from '../../context/SiteContext';
import './BrandLogo.css';

/**
 * Brand mark + wordmark for myfashiondeals.online
 * markOnly: favicon-style icon without text
 */
const BrandLogo = ({ className = '', markOnly = false, size = 32 }) => {
  const { siteName } = useSite();

  return (
    <span className={`brand-logo ${markOnly ? 'brand-logo--mark' : ''} ${className}`.trim()}>
      <svg
        className="brand-logo-mark"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        focusable="false"
      >
        <rect width="64" height="64" rx="14" fill="currentColor" className="brand-logo-mark-bg" />
        <path
          fill="#fff"
          d="M14 48V16h9.2l8.8 18.6L40.8 16H50v32h-7.6V28.4L34.2 48h-4.4L21.6 28.4V48H14z"
        />
        <circle cx="18.8" cy="20.2" r="3.4" fill="currentColor" className="brand-logo-mark-bg" />
      </svg>
      {!markOnly && <span className="brand-logo-text">{siteName}</span>}
      {markOnly && <span className="sr-only">{siteName}</span>}
    </span>
  );
};

export default BrandLogo;
